import { Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __assign, __extends } from 'tslib';
import { txpHideClass, isMobile } from '@tencent/thumbplayer-plugin-utils';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".txp_alert_info{position:absolute;left:10px;bottom:67px;padding:2px 8px;line-height:24px;font-size:13px;text-align:left;color:#fff;background:rgba(0,0,0,.6);-webkit-transition:bottom .15s ease;transition:bottom .15s ease;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.txp_alert_info.txp_none{display:none}.txp_alert_info.ctrl_resize{bottom:107px}.txp_alert_info.ctrl_hide{bottom:20px}.txp_alert_info .txp_btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;border:none;background:0 0;font-family:inherit;cursor:pointer;outline:0 none;font-size:1em}.txp_alert_info .txp_btn.txp_btn_close{position:relative;display:inline-block;margin-left:3px;width:14px;height:24px;vertical-align:top;color:#fff;cursor:pointer}.txp_alert_info .txp_btn.txp_btn_close:hover{color:#ff6429}.txp_alert_info .txp_btn.txp_btn_close:hover:before{background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI0ZGNzgwMCIgZD0iTTEwLjUgMTBsLS41LjUtNC00LTQgNC0uNS0uNSA0LTQtNC00IC41LS41IDQgNCA0LTQgLjUuNS00IDQgNCA0eiIvPjwvc3ZnPg==) 50% no-repeat}.txp_alert_info .txp_btn.txp_btn_close:before{content:\"\";position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:12px;height:12px;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjUgMTBsLS41LjUtNC00LTQgNC0uNS0uNSA0LTQtNC00IC41LS41IDQgNCA0LTQgLjUuNS00IDQgNCA0eiIvPjwvc3ZnPg==) 50% no-repeat;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;text-indent:0}.txp_alert_info .txp_btn.txp_none{display:none}.txp_alert_info .txp_alert_content a,.txp_alert_info .txp_alert_content em{padding:0 1px;color:#ff6429;font-style:normal;font-weight:400}.txp_alert_info .txp_alert_content .txp_alert_text{display:inline}.txp_alert_info .txp_none{display:none}";
styleInject(css_248z);

/** 热点广播的事件 */
var HOTPOINT_EVENTS;
(function (HOTPOINT_EVENTS) {
    HOTPOINT_EVENTS["HOT_MOUSE_OVER"] = "ctrl:hotpoint-mouseover";
    HOTPOINT_EVENTS["HOT_MOUSE_MOVE"] = "ctrl:hotpoint-mousemove";
    HOTPOINT_EVENTS["HOT_MOUSE_OUT"] = "ctrl:hotpoint-mouseout";
})(HOTPOINT_EVENTS || (HOTPOINT_EVENTS = {}));
var CtrlbarPluginName = 'ctrlbar';
/** 控制栏插件上广播的事件 */
var CTRL_EVENTS = __assign(__assign({ 
    /** 全屏状态变化 */
    FULLSCREEN_CHANGE: 'windowFullscreenChange', 
    /** 进入/退出全屏错误 */
    FULLSCREEN_ERROR: 'fullscreenError', 
    /** 伪全屏全屏状态变化 */
    FAKE_FULLSCREEN_CHANGE: 'browserFullscreenChange', 
    /** 点击画中画按钮 */
    CLICK_PIPBTN: 'ctrl:click-pipbtn', 
    /** 点击下一集按钮 */
    CLICK_NEXTBTN: 'ctrl:click-nextbtn', 
    /** 点击播放按钮 */
    CLICK_PLAYBTN: 'ctrl:click-playbtn', 
    /** 点击重播 */
    CLICK_REPLAY: 'ctrl:click-replay', 
    /** 点击循环播放按钮 */
    CLICK_LOOP: 'ctrl:click-loop', 
    /** 点击多语言 */
    SET_LANGUAGE: 'ctrl:set-language', 
    /** 点击清晰度 */
    SET_LEVEL: 'ctrl:set-level', 
    /** 点击多音轨 */
    SET_AUDIO: 'ctrl:set-audio', 
    /** 点击倍速 */
    SET_PLAYRATE: 'ctrl:set-playrate', 
    /** 拖拽音量 */
    SET_VOLUME: 'ctrl:set-volume', 
    /** 移动端浮层切换显隐 */
    TOGGLE_OVERLAY: 'ctrl:toggle-overlay', 
    /** @deprecated 拼写有错误，建议使用 MOUSE_DOWN，后续将删除 */
    MOUSE_DONW: 'ctrl:progress-mousedown', 
    /** 进度条 mousedown */
    MOUSE_DOWN: 'ctrl:progress-mousedown', 
    /** 进度条mousemove */
    MOUSE_MOVE: 'ctrl:progress-mousemove', 
    /** 进度条mouseup */
    MOUSE_UP: 'ctrl:progress-mouseup', 
    /** 进度条展示 */
    SHOW: 'ctrl:show', 
    /** 进度条隐藏 */
    HIDE: 'ctrl:hide' }, HOTPOINT_EVENTS), { 
    /** @ignore 移动端点击时间彩蛋事件，仅内部使用 */
    TEST_EVENT: 'ctrl:inner-test-event', 
    /** 控制栏尺寸发生变化，在进入全屏/伪全屏时广播 */
    RESIZE: 'ctrl:resize', 
    /** 展示清晰度浮层 */
    SHOW_LEVELS: 'ctrl:show-levels', 
    /** 鼠标hover至进度条上 */
    HOVER_PROGRESS: 'ctrl:hover-progress' });
var CTRL_SIZE;
(function (CTRL_SIZE) {
    CTRL_SIZE["LARGE"] = "large";
    CTRL_SIZE["NORMAL"] = "normal";
})(CTRL_SIZE || (CTRL_SIZE = {}));
var PlayBtnStatus;
(function (PlayBtnStatus) {
    PlayBtnStatus["PAUSE"] = "pause";
    PlayBtnStatus["PLAY"] = "play";
    PlayBtnStatus["REPLAY"] = "replay";
    PlayBtnStatus["STOP"] = "stop";
})(PlayBtnStatus || (PlayBtnStatus = {}));

/* eslint-disable @typescript-eslint/naming-convention */
/** show默认展示3s */
var defaultShowTime = 3;
/** 控制栏隐藏时增加此类名 */
var classNameOnCtrlHide = 'ctrl_hide';
/** 控制栏resize时增加此类名 */
var classNameOnCtrlResize = 'ctrl_resize';
/** 插件名 */
var TipsPluginName = 'tips';

var TipsPlugin = /** @class */ (function (_super) {
    __extends(TipsPlugin, _super);
    function TipsPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.hide = function () {
            _this.el.removeEventListener('click', _this.clickTips);
            _this.showOptions = null;
            _this.el.classList.add(txpHideClass);
            _this.emit(TipsEvents.Hide);
        };
        _this.clickTips = function (e) {
            var _a;
            if (!_this.showOptions) {
                return;
            }
            var callbackName = (_a = e.target) === null || _a === void 0 ? void 0 : _a.dataset.callback;
            if (!callbackName) {
                return;
            }
            if (typeof _this.showOptions[callbackName] === 'function') {
                _this.showOptions[callbackName]();
            }
        };
        _this.prepareDOM();
        _this.initDOMVars();
        if (config.followCtrlbar !== false) {
            _this.followCtrlbar();
        }
        return _this;
    }
    TipsPlugin.prototype.destroy = function () {
        this.hide();
        _super.prototype.destroy.call(this);
    };
    /**
     * 显示tip文案，可传入文本或者配置项。
     * @example
     * ```ts
     * // 传入文案
     * tips.show('正在缓冲中...');
     *
     * // 传入配置项
     * tips.show({
     *  text: '已为您跳转播放',
     *  // 展示5秒
     *  time: 5,
     * })
     *
     * // 传入可执行的回调函数
     * tips.show({
     *  text: `可试看 ${timeStr}，去腾讯视频观看完整版 <a href="javascript:;" data-callback="jumpToPage">立即前往</a>`,
     *  jumpToPage: () => {
     *    location.href = 'v.qq.com';
     *  },
     *  time: -1,
     * });
     * ```
     * @param option
     */
    TipsPlugin.prototype.show = function (option) {
        var text;
        var showClose = false;
        var time = defaultShowTime;
        if (typeof option === 'string' || typeof option === 'number') {
            text = String(option);
        }
        else {
            text = option.text;
            showClose = !!option.showClose;
            time = option.time || defaultShowTime;
            this.showOptions = option;
        }
        this.$text.innerHTML = text;
        this.$close.classList.toggle(txpHideClass, !showClose);
        this.el.addEventListener('click', this.clickTips);
        this.el.classList.remove(txpHideClass);
        clearTimeout(this.timeoutId);
        if (time !== -1) {
            this.timeoutId = window.setTimeout(this.hide, time * 1e3);
        }
        this.emit(TipsEvents.Show);
    };
    TipsPlugin.prototype.prepareDOM = function () {
        var container = this.player.container;
        var htmlStr = "<div class=\"txp_alert_content\">\n      <div class=\"txp_alert_text\"></div>\n      <button class=\"txp_btn txp_btn_close\" title=\"\u5173\u95ED\"></button>\n    </div>";
        var el = document.createElement('div');
        el.className = "txp_alert_info " + txpHideClass;
        el.innerHTML = htmlStr;
        container.insertAdjacentElement('beforeend', el);
        this.el = el;
    };
    TipsPlugin.prototype.initDOMVars = function () {
        this.$text = this.el.querySelector('.txp_alert_content .txp_alert_text');
        this.$close = this.el.querySelector('.txp_btn_close');
        this.$close.addEventListener('click', this.hide);
        // 略微适配下移动端
        if (isMobile) {
            this.el.style.bottom = '40px';
        }
    };
    TipsPlugin.prototype.followCtrlbar = function () {
        var _this = this;
        this.msg.on("pluginsetup:" + CtrlbarPluginName, function () {
            var ctrl = _this.player.plugins[CtrlbarPluginName];
            ctrl.on(CTRL_EVENTS.SHOW, function () {
                _this.el.classList.remove(classNameOnCtrlHide);
            });
            ctrl.on(CTRL_EVENTS.HIDE, function () {
                _this.el.classList.add(classNameOnCtrlHide);
            });
            ctrl.on(CTRL_EVENTS.RESIZE, function (_a) {
                var data = _a.data;
                _this.el.classList.toggle(classNameOnCtrlResize, data.size === CTRL_SIZE.LARGE);
            });
        });
    };
    TipsPlugin.pluginName = TipsPluginName;
    return TipsPlugin;
}(Plugin));
var TipsEvents;
(function (TipsEvents) {
    TipsEvents["Show"] = "show";
    TipsEvents["Hide"] = "hide";
})(TipsEvents || (TipsEvents = {}));

H5Player.registerPlugin(TipsPlugin.pluginName, TipsPlugin);

export { TipsEvents, TipsPlugin };
